<template>
  <div class="tables-basic">
    <div>
      <router-link to="wbs">
        <div class="floating-container">
          <div class="floating-button">
            <br />
            <b>#Berani Lapor</b>
          </div>
        </div></router-link
      >
    </div>
    <b-breadcrumb>
      <b-breadcrumb-item
        ><span class="fontbbi space2 text-secondary"
          >YOU ARE HERE</span
        ></b-breadcrumb-item
      >
      <b-breadcrumb-item active
        ><span class="fontbbi space2">Applications</span></b-breadcrumb-item
      >
    </b-breadcrumb>
    <h2 class="page-title">
      <span class="fw-semi-bold fontbbi space3">Applications</span>
    </h2>
    <b-row>
      <b-col cols="12" lg="6">
        <div class="d-flex m-2 align-items-center">
          <div>
            <label for="search" class="mr-2">Search</label>
          </div>
          <b-form-input
            id="search"
            v-model="search"
            placeholder="Search applications..."
            @input="filterApps"
            debounce="300"
          ></b-form-input>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="d-flex m-2 align-items-center">
          <div>
            <label for="category" class="mr-2">Category</label>
          </div>
          <b-form-select
            id="category"
            v-model="selectedCategory"
            :options="category_option"
            @change="filterApps"
            placeholder="Select a category"
            clearable
          ></b-form-select>
        </div>
      </b-col>
    </b-row>

    <!-- <b-row v-for="(data, group) in listApp" :key="group">
      <b-col>
        <Widget v-bind:title="populateGroupTitle(group)" customHeader>
          <div class="table-resposive overflow">
            <table class="table">
              <tbody>
                <tr align="left">
                  <td
                    align="center"
                    class="div-menu"
                    v-for="(row, index) in data"
                    :key="index"
                  >
                    <a
                      class="fontbbi space1 text-inverse"
                      v-if="row.enabled"
                      :href="replaceAppUrl(row.app_url, row.target)"
                      :target="chkUrlTarget(row.target)"
                    >
                      <div class="div-fill-all">
                        <img
                          class="img-rounded"
                          height="50"
                          :src="row.img_url"
                        />
                        <br />
                        {{ row.app_name }}
                        {{ row.name }}
                      </div>
                    </a>
                    <span v-else>
                      <img
                        class="img-rounded img-grayed"
                        height="50"
                        :src="row.img_url"
                      />
                      <br />
                      {{ row.app_name }}
                      {{ row.name }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Widget>
      </b-col>
    </b-row> -->

    <div class="d-flex flex-wrap justify-content-center mt-4" style="gap: 8px">
      <div
        v-for="(data, group) in filteredApplications"
        :key="group"
        style="
          flex: 1 1 250px; /* Ukuran tetap 200px */
          /* Batas lebar maksimal */
          min-width: 250px;
          max-width: 300px;
          justify-content: center;
        "
      >
        <div class="h-100">
          <b-card
            class="d-flex flex-row align-items-center shadow card-hover h-100"
            @click="cardClick(data, group)"
          >
            <b-card-text>
              <div class="d-flex">
                <div class="d-flex align-items-center mr-2">
                  <img
                    class="img-rounded"
                    height="50"
                    :src="imgUrl(data.detail)"
                  />
                </div>
                <div
                  class="d-flex flex-column justify-content-between w-100"
                  style="font-size: 10px"
                >
                  <div class="d-flex flex-column">
                    <strong>{{ data.title }} </strong>
                    <span>{{ data.desc }}</span>
                  </div>
                  <div class="d-flex">
                    <div v-if="data.detail.length <= 1">
                      <b-button
                        style="padding: 1px 4px; font-size: 9px"
                        variant="success"
                        size="sm"
                        @click.stop="
                          toApps(data.detail[0].app_url, data.detail[0].target)
                        "
                      >
                        <div>Apps</div>
                      </b-button>
                    </div>
                    <div v-else>
                      <div v-if="visibleCollapse[group]">
                        <b-button
                          @click.stop="toggleCollapseClose(group)"
                          style="padding: 1px 4px; font-size: 9px"
                          variant="primary"
                          class="d-flex align-items-center"
                          size="sm"
                        >
                          <div class="mr-1">See less</div>
                          <b-icon icon="caret-up-fill"></b-icon>
                        </b-button>
                      </div>
                      <div v-if="!visibleCollapse[group]">
                        <b-button
                          @click.stop="toggleCollapse(group)"
                          style="padding: 1px 4px; font-size: 9px"
                          variant="primary"
                          class="d-flex align-items-center"
                          size="sm"
                        >
                          <div class="mr-1">See more</div>
                          <b-icon icon="caret-down-fill"></b-icon>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-card>
          <div
            style="z-index: 99999; position: absolute; margin-top: -25px"
            class="d-flex justify-content-center"
          >
            <b-collapse
              :visible="visibleCollapse[group]"
              class="mt-2 shadow"
              style="
                display: absolute;
                z-index: 9999;
                transform: translate(72px, 0px);
                background-color: aliceblue;
              "
            >
              <div class="shadow py-2" rounded>
                <div
                  v-for="(data, index) in data.detail"
                  :key="index"
                  class="px-2"
                  rounded
                >
                  <b-button
                    style="padding: 2px 4px; font-size: 10px"
                    variant="success"
                    size="sm"
                    class="block w-100"
                    @click="toApps(data.app_url, data.target)"
                    ><div>{{ data.name }}</div></b-button
                  >
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <Loader
        v-if="isLoading"
        fullPage
        useOverlay
        loader="spinner"
      ></Loader>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Widget from "@/components/Widget/Widget";
import { fnPOST, fnPOSTCore } from "../../api/api-methods";
import { APIPATH_BBIAPPS } from "../../api/api-paths";
import Loader from "@/components/Loader/Loader";
// import appsStore from '@/store/apiApps.js';

export default {
  name: "Applications",
  components: { 
    Widget,
    Loader
   },

  data() {
    return {
      listApp: null,
      isLoading: false,
      applicationsData: [],
      visibleCollapse: [],
      bCollapse: null,
      search: "",
      category_option: [],
      selectedCategory: "All",
      filteredApplications: [],
    };
  },
  computed: {
    ...mapState("application", ["stAppAccess"]),
    ...mapGetters("session", ["userData"]),
    // filteredApplications() {
    //   // Filter aplikasi berdasarkan nilai pencarian
    //   if (!this.search) {
    //     return this.applicationsData;
    //   }
    //   const searchTerm = this.search.toLowerCase();
    //   return this.applicationsData.filter((app) =>
    //     app.title.toLowerCase().includes(searchTerm)
    //   );
    // },
  },
  watch: {
    search() {
      this.filterApps();
    },
    selectedCategory() {
      this.filterApps();
    },
  },
  methods: {
    ...mapActions("application", ["clearState", "getApplicationAccess"]),
    populateGroupTitle(title) {
      this.curGroup = title;
      return "<h5><span class='fw-semi-bold'>" + title + "</span></h5>";
    },
    cardClick(data, group) {
      console.log(data);
      this.cekColapse(group);
      if (data.detail.length <= 1) {
        this.toApps(data.detail[0].app_url, data.detail[0].target);
      } else {
        if (this.visibleCollapse[group]) {
          this.toggleCollapseClose(group);
        } else {
          this.toggleCollapse(group);
        }
      }
    },
    filterApps() {
      const query = this.search.toLowerCase();
      const selectedCategory = this.selectedCategory; // ID kategori yang dipilih

      // Filter aplikasi berdasarkan pencarian dan kategori
      this.filteredApplications = this.applicationsData.filter((app) => {
        // Filter berdasarkan pencarian judul
        const matchesSearch = app.title.toLowerCase().includes(query);

        // Filter berdasarkan kategori yang dipilih
        let matchesCategory = true; // Default ke true jika "All" dipilih
        if (selectedCategory != "All") {
          // Jika kategori yang dipilih bukan "All", filter berdasarkan kategori
          matchesCategory = app.category.some(
            (cat) => cat=== selectedCategory
          );
        }

        return matchesSearch && matchesCategory; // Gabungkan pencarian dan kategori
      });
    },
    toggleCollapse(index) {
      // Toggle the collapse visibility for each group
      this.bCollapse = index;
      this.visibleCollapse = this.visibleCollapse.map(() => false);
      this.$set(this.visibleCollapse, index, !this.visibleCollapse[index]);
    },
    cekColapse(index) {
      if (this.bCollapse != index) {
        this.visibleCollapse = this.visibleCollapse.map(() => false);
      }
    },
    searchApps() {
      let temp = this.applicationsData;
      let data = temp.filter((item) => item.title.includes(this.search));
      return data;
    },
    toggleCollapseClose(index) {
      // console.log(index);
      // Toggle the collapse visibility for each group
      // this.visibleCollapse = this.visibleCollapse.map(() => false);
      this.$set(this.visibleCollapse, index, !this.visibleCollapse[index]);
    },
    imgUrl(dataDetail) {
      let url = dataDetail.filter((item) => item.image_url != "")[0].img_url;
      // console.log(url);
      return url;
    },
    toApps(urlData, target) {
      let url = this.replaceAppUrl(urlData, target);
      // console.log(url);

      if (target == "NEW_TAB" || target == "NEW_WINDOW") {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },
    replaceAppUrl(formUrl, targetUrl) {
      let userData = JSON.parse(localStorage.userData);
      let nik = userData.nik;
      let name = userData.fullname;
      let dept = userData.dept;
      let deptName = userData.deptname;
      let role = userData.role;
      let loginId = userData.username;
      let bunit = userData.business_unit;
      let url = formUrl
        .replace("_NIK_", nik)
        .replace("_FULLNAME_", name)
        .replace("_DEPARTMENT_", dept)
        .replace("_DEPARTMENTNAME_", deptName)
        .replace("_ROLE_", role)
        .replace("_LOGINID_", loginId)
        .replace("_BUSINESSUNIT_", bunit);

      let chkUrlString = formUrl.substring(0, 3);
      let curlUrl = new URL(window.location.href);
      if (targetUrl == "NEW_TAB" || targetUrl == "NEW_WINDOW") {
        return url;
      } else {
        return curlUrl.origin + url;
      }
    },
    chkUrlTarget(formUrl) {
      // console.log(formUrl)
      if (formUrl == "NEW_TAB" || formUrl == "NEW_WINDOW") {
        return "_blank";
      } else {
        return "_self";
      }
    },
    processAppPayload(payload) {
      let items = payload;
      let lookup = {};
      let result = [];
      for (let i = 0; i < items.length; i++) {
        let tempAppList = items[i];
        let name = tempAppList.group;
        if (!(name in lookup)) {
          lookup[name] = 1;
          result.push(name);
        }
      }
      let newData = this.groupBy(payload, "group");
      this.$set(this, "listApp", newData);
      // console.log(this.listApp);

      let application = Object.values(
        items.reduce((acc, item) => {
          const groupName = item.group;
          if (!acc[groupName]) {
            acc[groupName] = {
              title: groupName.toUpperCase(),
              category: item.category,
              category_name: item.category_name,
              detail: [],
              desc: "",
            };
          }
          if (item.desc && item.desc.length > 4) {
            acc[groupName].desc = item.desc;
          }
          acc[groupName].detail.push({
            name: item.name,
            app_url: item.app_url,
            img_url: item.img_url,
            target: item.target,
            enabled: item.enabled,
          });
          return acc;
        }, {})
      );
      // this.$set(this, "applicationsData", application);
      this.applicationsData = application;
      this.filterApps();
      console.log("test", application);
      // this.filteredApplications = application;
      // console.log("test", application);
    },
    groupBy(data, key) {
      const result = {};
      let jsonArr = data;
      let array = [];

      for (let i = 0; i < jsonArr.length; i++) {
        let tempApp = jsonArr[i];

        array.push(tempApp);
      }
      array.forEach((item) => {
        if (item["enabled"] == true) {
          if (!result[item[key]]) {
            result[item[key]] = [];
          }
          result[item[key]].push(item);
        }
      });
      return result;
    },
    handleClickOutside(event) {
      const cardElements = document.querySelectorAll(".card-hover");
      let isClickInsideCard = false;

      cardElements.forEach((card) => {
        if (card.contains(event.target)) {
          isClickInsideCard = true;
        }
      });

      if (!isClickInsideCard) {
        // Tutup semua collapse
        this.visibleCollapse = this.visibleCollapse.map(() => false);
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
    let usrBU = this.userData.business_unit;
    let dept = this.userData.deptname;
    let subdept = this.userData.subdeptname;
    let role = this.userData.role;
    let roles_app = this.userData.roles;
    this.clearState();

    // if(usrBU == 'BBI1' || usrBU == 'BBI') {
    this.isLoading = true;
    fnPOSTCore(APIPATH_BBIAPPS.appRoleList, {
      roles_app: roles_app,
    }).then((rsp) => {
      this.category_option = rsp.data.payload.category;
      this.category_option = this.category_option.map((item) => {
        return {
          value: item.id, // ID kategori sebagai nilai
          text: item.name,
        };
      });
      this.category_option.unshift({ value: "All", text: "All" });
      this.processAppPayload(rsp.data.payload.app_list);
    })
    .finally(() => {
      this.isLoading = false;
    });

    // }
    // else {
    //  fnPOSTCore(APIPATH_BBIAPPS.appAccessSmg, {
    //     businessunit: usrBU,
    //     role: role,
    //     dept: dept,
    //     subdept: subdept,
    //     roles_app: roles_app,
    //  }).then(rsp => {
    //     this.processAppPayload(rsp.data.payload.app_list)
    //   })

    // this.getApplicationAccess({
    //   businessunit: usrBU,
    //   role: role,
    //   dept: dept,
    //   subdept: subdept,
    // })
    // this.$set(this, "listApp", this.stAppAccess);
    // }
  },
};
</script>

<style src="./Applications.scss" lang="scss" scoped />
<style scoped>
.card-hover {
  transition: all 0.1s ease-in-out;

  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.card-hover:hover {
  transform: scale(1.05);
  background-color: #e9ecef;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}
</style>
